import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMouseDown"><Path d="M16 11.25L11.9999 15.25L8 11.25" stroke="currentColor"/><Path d="M12 14.7905V4" stroke="currentColor" strokeLinejoin="round"/><Path d="M18.6711 10.7998C20.5662 11.7176 21.75 13.0219 21.75 14.4688C21.75 17.2474 17.3848 19.4998 12 19.4998C6.61522 19.4998 2.25 17.2474 2.25 14.4688C2.25 13.0219 3.43381 11.7176 5.32895 10.7998" stroke="currentColor"/></CentralIconBase>;
});

export default IconMouseDown;
